module.exports = __webpack_public_path__ + "static/media/06.c6fe7da2.jpg";